/**
 * 구역 이름 — 층이 앞, 번호가 뒤 (B1_1, B1_2 …). 층마다 1번 구역이 따로 있어서
 * 번호만 쓰면 층끼리 이름이 겹친다. 층을 모르면 예전처럼 'N구역'.
 */
export function floorZoneName(floor: string | undefined, n: number | string): string {
  const f = floor?.trim()
  return f ? `${f}_${n}` : `${n}구역`
}

/** 이름에서 구역 번호 — 마지막 숫자 (B1_3 → 3, 3구역 → 3). 없으면 fallback. */
export function zoneNumberFromName(name: string, fallback: number): string {
  const m = name.match(/(\d+)\D*$/)
  return m ? m[1] : String(fallback)
}

/** 아직 안 쓴 다음 구역 이름 — taken 에 없는 가장 작은 start 이상의 번호. */
export function nextFloorZoneName(
  floor: string | undefined,
  taken: Iterable<string>,
  start = 1
): string {
  const used = new Set(taken)
  let n = Math.max(1, start)
  while (used.has(floorZoneName(floor, n))) n += 1
  return floorZoneName(floor, n)
}
